var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--xlarge"},[_vm._m(0),_c('section',[_c('div',{staticClass:"o-grid o-grid--no-gutter"},[_vm._m(1),_c('div',{staticClass:"o-grid__cell top-buttons"},[_c('bos-button',{on:{"click":_vm.newBoothService}},[_vm._v("Neue Stand-Leistung")])],1)]),_c('bos-overview-table',{attrs:{"data":_vm.boothServices,"columns":[
        {
          key: 'title',
          name: 'Name'
        }
      ],"deleteTitle":"Stand-Leistung löschen","deleteText":obj =>
          'Soll die Stand-Leistung <b>"' +
          obj.title +
          '"</b> wirklich gelöscht werden?',"onEdit":_vm.editBoothService,"onDelete":_vm.deleteBoothService,"disableDelete":obj => obj.isUsed}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',[_vm._v("Stammdaten bearbeiten")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-grid__cell"},[_c('h4',[_vm._v("Stand-Leistungen")])])
}]

export { render, staticRenderFns }